export default __webpack_public_path__ + "static/media/Hive Khopesh.d8ab6272.jpg";